import React from "react";

const BurgerMenuIcon = ({ fontSize }) => {
  return (
    <svg
      width={fontSize ? `${fontSize}rem` : "1.6rem"}
      height={fontSize ? `${fontSize}rem` : "1.6rem"}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496 496"
      style={{ enableBackground: "new 0 0 496 496" }}
    >
      <g>
        <path
          style={{ fill: "#09A7BC" }}
          d="M472.8,128H23.2C10.4,128,0,116.8,0,104s10.4-24,23.2-24h449.6c12.8,0,23.2,11.2,23.2,24
     C496,116.8,485.6,128,472.8,128z"
        />
        <path
          style={{ fill: "#09A7BC" }}
          d="M472.8,272H23.2C10.4,272,0,260.8,0,248c0-12.8,10.4-24,23.2-24h449.6c12.8,0,23.2,11.2,23.2,24
     C496,260.8,485.6,272,472.8,272z"
        />
        <path
          style={{ fill: "#09A7BC" }}
          d="M472.8,416H23.2C10.4,416,0,404.8,0,392s10.4-24,23.2-24h449.6c12.8,0,23.2,11.2,23.2,24
     C496,404.8,485.6,416,472.8,416z"
        />
      </g>
      <g>
        <path
          style={{ fill: "#2EC0EE" }}
          d="M472.8,368h-108l46.4,48H472c12.8,0,23.2-11.2,23.2-24C496,379.2,485.6,368,472.8,368z"
        />
        <path
          style={{ fill: "#2EC0EE" }}
          d="M472.8,224H222.4l46.4,48H472c12.8,0,23.2-11.2,23.2-24C495.2,235.2,485.6,224,472.8,224z"
        />
        <path
          style={{ fill: "#2EC0EE" }}
          d="M472.8,80H80l46.4,48H472c12.8,0,23.2-11.2,23.2-24C496,91.2,485.6,80,472.8,80z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

export default BurgerMenuIcon;
